import React from "react";
import { useUsers } from "../../../hooks/useUsers";
import { useForm, Controller } from "react-hook-form";
import { CustomInputSelect } from "../../CustomInputSelect";
import { CustomButtonsForm } from "../../CustomButtonsForm";

export const ReAssignForm = ({ user, action }) => {

    const { users } = useUsers();
	const { handleSubmit, control, formState:{ errors } } = useForm();

	return (
        <form 
            onSubmit={ handleSubmit(action) }
            style={{ 
                background: "#fff",
				width: '25vw',
				padding: 20,
				overflowY: 'auto',
				scrollbarWidth: 'none' 
            }}
        >
            <Controller
				name='responsable'
				control={ control }
				render={ ({ field: { onChange, value } }) => (
					<CustomInputSelect
						label='Nuevo responsable'
						options={ users?.filter(u => u?.uid !== user?._id)?.map(user => ({ ...user, name: user?.nombre })) }
						onChange={ onChange }
						value={ value }
						error={ errors?.responsable }
					/>
				)}

				rules={{ required: '* El campo es obligatorio.' }}
			/>

            <CustomButtonsForm name='Asignar' />
        </form>
    )
}